<template>
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="min-h-screen bg-gray-50">
        <div class="px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <Breadcrumbs
            :breadcrumbs="[
              { name: 'Dashboard', href: route('dashboard') },
              { name: 'Pemilihan', href: route('pemilihan.index') },
              { name: `${data?.judul || 'Detail Kegiatan'}` },
            ]"
          />

          <div class="mb-8">
            <h1 class="text-3xl font-bold text-gray-900">
              Detail Kegiatan Pemilihan
            </h1>
            <p class="mt-2 text-lg text-gray-600">
              Informasi lengkap kegiatan pemilihan
            </p>
          </div>

          <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
            <!-- Information Card -->
            <div class="order-2 lg:col-span-2">
              <div class="bg-white border border-gray-200 shadow-lg rounded-xl">
                <div
                  class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4"
                >
                  <h2
                    class="flex items-center text-lg font-bold text-white sm:text-xl"
                  >
                    <i class="mr-2 fa-solid fa-check-to-slot sm:mr-3"></i>
                    Informasi Kegiatan
                  </h2>
                </div>
                <div class="p-4 sm:p-6">
                  <dl class="divide-y divide-gray-200">
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
                      <dt class="text-sm font-semibold text-gray-900">Judul</dt>
                      <dd class="text-sm font-medium text-gray-700 sm:col-span-2">
                        {{ data?.judul || "-" }}
                      </dd>
                    </div>
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
                      <dt class="text-sm font-semibold text-gray-900">
                        Keterangan
                      </dt>
                      <dd
                        v-if="data?.keterangan"
                        class="ql-snow ql-editor !h-auto !overflow-visible !p-0 text-sm text-gray-700 sm:col-span-2 break-words"
                        v-html="data.keterangan"
                      ></dd>
                      <dd v-else class="text-sm text-gray-700 sm:col-span-2">
                        -
                      </dd>
                    </div>
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
                      <dt class="text-sm font-semibold text-gray-900">
                        Tanggal
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        <div class="flex flex-col space-y-1">
                          <span>Mulai: {{ data?.tanggal_mulai || "-" }}</span>
                          <span
                            >Selesai: {{ data?.tanggal_selesai || "-" }}</span
                          >
                        </div>
                      </dd>
                    </div>
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
                      <dt class="text-sm font-semibold text-gray-900">
                        Status
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        <span
                          :class="{
                            'bg-green-100 text-green-800':
                              data?.status === 'selesai',
                            'bg-blue-100 text-blue-800':
                              data?.status === 'terjadwal',
                            'bg-yellow-100 text-yellow-800':
                              data?.status === 'berlangsung',
                            'bg-red-100 text-red-800':
                              data?.status === 'dibatalkan',
                          }"
                          class="inline-flex items-center px-3 py-1 text-xs font-medium capitalize rounded-full"
                        >
                          {{ data?.status || "-" }}
                        </span>
                      </dd>
                    </div>
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
                      <dt class="text-sm font-semibold text-gray-900">
                        Lampiran Pengumuman
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        <div
                          v-if="data?.lampiran_pengumuman?.length"
                          class="space-y-1"
                        >
                          <a
                            v-for="(item, idx) in data.lampiran_pengumuman"
                            :key="idx"
                            :href="item.file"
                            target="_blank"
                            rel="noopener"
                            class="flex items-center gap-2 text-indigo-600 hover:underline"
                          >
                            <i class="fa-solid fa-paperclip"></i>
                            {{ item.nama }}
                          </a>
                        </div>
                        <span v-else>-</span>
                      </dd>
                    </div>
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
                      <dt class="text-sm font-semibold text-gray-900">
                        Lampiran Dokumen
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        <div
                          v-if="data?.lampiran_dokumen?.length"
                          class="space-y-1"
                        >
                          <a
                            v-for="(item, idx) in data.lampiran_dokumen"
                            :key="idx"
                            :href="item.file"
                            target="_blank"
                            rel="noopener"
                            class="flex items-center gap-2 text-indigo-600 hover:underline"
                          >
                            <i class="fa-solid fa-paperclip"></i>
                            {{ item.nama }}
                          </a>
                        </div>
                        <span v-else>-</span>
                      </dd>
                    </div>
                  </dl>
                </div>

                <div
                  v-if="$page.props.auth.user"
                  class="px-4 py-4 border-t border-gray-200 bg-gray-50 rounded-b-xl sm:px-6"
                >
                  <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    <button
                      @click="openEditModal"
                      class="inline-flex items-center justify-center px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 rounded-lg shadow-sm hover:bg-indigo-700"
                    >
                      <i class="mr-2 fa-solid fa-edit"></i>
                      Edit Data
                    </button>
                    <button
                      @click="isModalGambar = true"
                      class="inline-flex items-center justify-center px-4 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50"
                    >
                      <i class="mr-2 fa-solid fa-image"></i>
                      Ganti Gambar
                    </button>
                    <button
                      @click="openLampiranModal('pengumuman')"
                      class="inline-flex items-center justify-center px-4 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50"
                    >
                      <i class="mr-2 fa-solid fa-paperclip"></i>
                      Lampiran Pengumuman
                    </button>
                    <button
                      @click="openLampiranModal('dokumen')"
                      class="inline-flex items-center justify-center px-4 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50"
                    >
                      <i class="mr-2 fa-solid fa-paperclip"></i>
                      Lampiran Dokumen
                    </button>
                    <button
                      @click="confirmDelete"
                      class="inline-flex items-center justify-center px-4 py-2.5 text-sm font-semibold text-white bg-red-600 rounded-lg shadow-sm hover:bg-red-700 sm:col-span-2"
                    >
                      <i class="mr-2 fa-solid fa-trash"></i>
                      Hapus
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Image Section -->
            <div class="order-1">
              <div class="bg-white border border-gray-200 shadow-lg rounded-xl">
                <div
                  class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4"
                >
                  <h2
                    class="flex items-center text-lg font-bold text-white sm:text-xl"
                  >
                    <i class="mr-2 fa-solid fa-image sm:mr-3"></i>
                    Gambar Kegiatan
                  </h2>
                </div>
                <div class="p-4 sm:p-6">
                  <div
                    v-if="data?.gambar?.length"
                    class="grid grid-cols-2 gap-4 sm:grid-cols-3"
                  >
                    <img
                      v-for="(img, idx) in data.gambar"
                      :key="idx"
                      :src="img"
                      class="object-cover w-full border border-gray-200 rounded-lg shadow-sm h-40"
                    />
                  </div>
                  <div
                    v-else
                    class="relative flex flex-col items-center justify-center h-64 border-2 border-gray-200 border-dashed rounded-lg bg-gray-50"
                  >
                    <i class="mb-3 text-4xl text-gray-400 fa-solid fa-image"></i>
                    <span class="text-sm text-gray-500">Belum ada gambar</span>
                  </div>
                </div>
              </div>

              <!-- Modal Edit -->
              <div
                v-if="isModalOpen"
                class="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black bg-opacity-50"
              >
                <div
                  class="relative flex flex-col w-full max-w-2xl mx-auto bg-white shadow-xl rounded-xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden"
                >
                  <div
                    class="flex-shrink-0 px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4"
                  >
                    <div class="flex items-center justify-between gap-3">
                      <h3 class="text-base font-bold text-white truncate sm:text-lg">
                        Edit Kegiatan
                      </h3>
                      <button
                        type="button"
                        @click="isModalOpen = false"
                        class="flex-shrink-0 text-white hover:text-gray-200"
                      >
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                  </div>
                  <form
                    @submit.prevent="submitEdit"
                    class="flex flex-col flex-1 min-h-0"
                  >
                    <div class="flex-1 p-4 space-y-4 overflow-y-auto sm:p-6 sm:space-y-6">
                      <div>
                        <label class="block mb-2 text-sm font-semibold text-gray-700"
                          >Judul</label
                        >
                        <input
                          type="text"
                          v-model="editForm.judul"
                          class="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500"
                          required
                        />
                        <InputError :message="editForm.errors.judul" class="mt-2" />
                      </div>
                      <div class="grid grid-cols-1 gap-4 sm:gap-6 sm:grid-cols-2">
                        <div>
                          <label
                            class="block mb-2 text-sm font-semibold text-gray-700"
                            >Tanggal Mulai</label
                          >
                          <input
                            type="date"
                            v-model="editForm.tanggal_mulai"
                            class="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500"
                            required
                          />
                          <InputError
                            :message="editForm.errors.tanggal_mulai"
                            class="mt-2"
                          />
                        </div>
                        <div>
                          <label
                            class="block mb-2 text-sm font-semibold text-gray-700"
                            >Tanggal Selesai</label
                          >
                          <input
                            type="date"
                            v-model="editForm.tanggal_selesai"
                            class="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500"
                          />
                          <InputError
                            :message="editForm.errors.tanggal_selesai"
                            class="mt-2"
                          />
                        </div>
                      </div>
                      <div>
                        <label class="block mb-2 text-sm font-semibold text-gray-700"
                          >Status</label
                        >
                        <select
                          v-model="editForm.status"
                          class="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500"
                          required
                        >
                          <option value="terjadwal">Terjadwal</option>
                          <option value="berlangsung">Berlangsung</option>
                          <option value="selesai">Selesai</option>
                          <option value="dibatalkan">Dibatalkan</option>
                        </select>
                        <InputError :message="editForm.errors.status" class="mt-2" />
                      </div>
                      <div>
                        <label class="block mb-2 text-sm font-semibold text-gray-700"
                          >Keterangan</label
                        >
                        <QuillEditor
                          v-model="editForm.keterangan"
                          :error="editForm.errors.keterangan"
                        />
                      </div>
                    </div>
                    <div
                      class="flex-shrink-0 px-4 py-3 border-t border-gray-200 bg-gray-50 sm:px-6 sm:py-4 rounded-b-xl"
                    >
                      <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end sm:space-x-3 sm:gap-0">
                        <button
                          type="button"
                          @click="isModalOpen = false"
                          class="px-6 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                        >
                          Batal
                        </button>
                        <button
                          type="submit"
                          :disabled="editForm.processing"
                          class="px-6 py-2.5 text-sm font-semibold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 disabled:opacity-50"
                        >
                          {{ editForm.processing ? "Menyimpan..." : "Simpan Perubahan" }}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <!-- Modal Gambar -->
              <div
                v-if="isModalGambar"
                class="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black bg-opacity-50"
              >
                <div class="relative w-full max-w-md mx-auto bg-white shadow-xl rounded-xl max-h-[95vh] overflow-y-auto">
                  <div
                    class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4"
                  >
                    <div class="flex items-center justify-between gap-3">
                      <h3 class="text-base font-bold text-white truncate sm:text-lg">Ganti Gambar</h3>
                      <button
                        type="button"
                        @click="isModalGambar = false"
                        class="flex-shrink-0 text-white hover:text-gray-200"
                      >
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                  </div>
                  <form @submit.prevent="submitGambar">
                    <div class="p-4 sm:p-6">
                      <input
                        type="file"
                        multiple
                        accept="image/*"
                        @change="onGambarChange"
                        class="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700"
                        required
                      />
                      <p class="mt-2 text-xs text-gray-500">
                        Format: JPG, JPEG, PNG. Maksimal 2MB per gambar. Gambar lama akan digantikan.
                      </p>
                    </div>
                    <div class="px-4 py-3 border-t border-gray-200 bg-gray-50 sm:px-6 sm:py-4 rounded-b-xl">
                      <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end sm:space-x-3 sm:gap-0">
                        <button
                          type="button"
                          @click="isModalGambar = false"
                          class="px-6 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                        >
                          Batal
                        </button>
                        <button
                          type="submit"
                          :disabled="gambarForm.processing"
                          class="px-6 py-2.5 text-sm font-semibold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 disabled:opacity-50"
                        >
                          {{ gambarForm.processing ? "Mengupload..." : "Upload" }}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <!-- Modal Lampiran (Pengumuman / Dokumen) -->
              <div
                v-if="isModalLampiran"
                class="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black bg-opacity-50"
              >
                <div class="relative w-full max-w-md mx-auto bg-white shadow-xl rounded-xl max-h-[95vh] overflow-y-auto">
                  <div
                    class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4"
                  >
                    <div class="flex items-center justify-between gap-3">
                      <h3 class="text-base font-bold text-white truncate sm:text-lg">
                        Ganti Lampiran {{ lampiranType === "pengumuman" ? "Pengumuman" : "Dokumen" }}
                      </h3>
                      <button
                        type="button"
                        @click="isModalLampiran = false"
                        class="flex-shrink-0 text-white hover:text-gray-200"
                      >
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                  </div>
                  <form @submit.prevent="submitLampiran">
                    <div class="p-4 space-y-3 sm:p-6">
                      <input
                        type="file"
                        multiple
                        accept=".pdf,.doc,.docx"
                        @change="onLampiranChange"
                        class="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700"
                        required
                      />
                      <div v-if="lampiranForm.file.length" class="space-y-2">
                        <div
                          v-for="(file, i) in lampiranForm.file"
                          :key="i"
                          class="flex items-center gap-2"
                        >
                          <span
                            class="flex-shrink-0 text-xs text-gray-500 truncate w-24"
                            :title="file.name"
                            >{{ file.name }}</span
                          >
                          <input
                            v-model="lampiranForm.nama[i]"
                            type="text"
                            placeholder="Nama lampiran"
                            class="block w-full px-3 py-1.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                          />
                        </div>
                      </div>
                      <InputError :message="lampiranForm.errors[`${lampiranPrefix}_nama`]" />
                      <p class="text-xs text-gray-500">
                        Format: PDF, DOC, DOCX. Maksimal 5MB per file. Lampiran lama akan digantikan.
                      </p>
                    </div>
                    <div class="px-4 py-3 border-t border-gray-200 bg-gray-50 sm:px-6 sm:py-4 rounded-b-xl">
                      <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end sm:space-x-3 sm:gap-0">
                        <button
                          type="button"
                          @click="isModalLampiran = false"
                          class="px-6 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                        >
                          Batal
                        </button>
                        <button
                          type="submit"
                          :disabled="lampiranForm.processing"
                          class="px-6 py-2.5 text-sm font-semibold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 disabled:opacity-50"
                        >
                          {{ lampiranForm.processing ? "Mengupload..." : "Upload" }}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { computed, ref } from "vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Container from "@/Layouts/Container.vue";
import QuillEditor from "@/Components/QuillEditor.vue";
import Header from "@/Components/Header.vue";
import InputError from "@/Components/InputError.vue";
import Swal from "sweetalert2";
import { router, useForm } from "@inertiajs/vue3";

const props = defineProps({
  pemilihan: {
    type: Object,
    required: true,
  },
});

const data = computed(() => props.pemilihan?.data || props.pemilihan);

const isModalOpen = ref(false);
const isModalGambar = ref(false);
const isModalLampiran = ref(false);
const lampiranType = ref("pengumuman"); // 'pengumuman' | 'dokumen'
const lampiranPrefix = computed(() => `lampiran_${lampiranType.value}`);

const editForm = useForm({
  judul: "",
  keterangan: "",
  tanggal_mulai: "",
  tanggal_selesai: "",
  status: "",
});

const gambarForm = useForm({ gambar: [] });
const lampiranForm = useForm({ file: [], nama: [] });

function openLampiranModal(type) {
  lampiranType.value = type;
  lampiranForm.reset();
  lampiranForm.clearErrors();
  isModalLampiran.value = true;
}

function openEditModal() {
  editForm.judul = data.value.judul || "";
  editForm.keterangan = data.value.keterangan || "";
  editForm.tanggal_mulai = data.value.tanggal_mulai || "";
  editForm.tanggal_selesai = data.value.tanggal_selesai || "";
  editForm.status = data.value.status || "";
  isModalOpen.value = true;
}

function submitEdit() {
  editForm.put(route("pemilihan.update", data.value.idpemilihan), {
    onSuccess: () => {
      isModalOpen.value = false;
      Swal.fire({
        title: "Berhasil!",
        text: "Kegiatan berhasil diperbarui.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
    },
    onError: () => {
      Swal.fire({
        title: "Gagal!",
        text: "Terjadi kesalahan saat memperbarui data.",
        icon: "error",
      });
    },
    preserveScroll: true,
  });
}

function onGambarChange(e) {
  gambarForm.gambar = Array.from(e.target.files);
}

function submitGambar() {
  gambarForm.post(route("pemilihan.updateGambar", data.value.idpemilihan), {
    forceFormData: true,
    onSuccess: () => {
      isModalGambar.value = false;
      gambarForm.reset();
      Swal.fire({
        title: "Berhasil!",
        text: "Gambar berhasil diperbarui.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
    },
    onError: (errors) => {
      Swal.fire({
        title: "Gagal!",
        text: errors.gambar || "Terjadi kesalahan saat mengupload gambar.",
        icon: "error",
      });
    },
    preserveScroll: true,
  });
}

function onLampiranChange(e) {
  lampiranForm.file = Array.from(e.target.files);
  lampiranForm.nama = lampiranForm.file.map(() => "");
}

function submitLampiran() {
  const routeName =
    lampiranType.value === "pengumuman"
      ? "pemilihan.updateLampiranPengumuman"
      : "pemilihan.updateLampiranDokumen";
  const prefix = lampiranPrefix.value;

  lampiranForm
    .transform((formData) => ({
      [`${prefix}_file`]: formData.file,
      [`${prefix}_nama`]: formData.nama,
    }))
    .post(route(routeName, data.value.idpemilihan), {
      forceFormData: true,
      onSuccess: () => {
        isModalLampiran.value = false;
        lampiranForm.reset();
        Swal.fire({
          title: "Berhasil!",
          text: "Lampiran berhasil diperbarui.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      },
      onError: () => {
        Swal.fire({
          title: "Gagal!",
          text: "Terjadi kesalahan saat mengupload lampiran.",
          icon: "error",
        });
      },
      preserveScroll: true,
    });
}

function confirmDelete() {
  Swal.fire({
    title: "Apakah Anda yakin?",
    text: "Kegiatan ini akan dihapus secara permanen!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Ya, hapus!",
    cancelButtonText: "Batal",
  }).then((result) => {
    if (result.isConfirmed) {
      router.delete(route("pemilihan.destroy", data.value.idpemilihan), {
        onSuccess: () => {
          Swal.fire({
            title: "Berhasil!",
            text: "Kegiatan berhasil dihapus.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          }).then(() => {
            router.visit(route("pemilihan.index"));
          });
        },
        onError: () => {
          Swal.fire({
            title: "Gagal!",
            text: "Terjadi kesalahan saat menghapus kegiatan.",
            icon: "error",
          });
        },
      });
    }
  });
}
</script>
